import { useState } from 'react'
import { useRouter } from 'next/router'
import { useWishlist } from './use-wishlist'
import {
    MutationMoveProductsBetweenWishlistsArgs,
    MoveProductsBetweenWishlistsOutput
} from '@pylot-data/pylotschema'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { MOVE_PRODUCTS_BETWEEN_WISHLISTS } from '../graphql/moveProductsBetweenWishlists'

export interface OutputInterface {
    moveProductsBetweenWishlists: MoveProductsBetweenWishlistsOutput
}

export interface UseMoveProductsBetweenWishlistInterface {
    isLoading: boolean
    moveProductsBetweenWishlists: (
        formInput: MutationMoveProductsBetweenWishlistsArgs
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
}

export const useMoveProductsBetweenWishlists =
    (): UseMoveProductsBetweenWishlistInterface => {
        const { locale } = useRouter()
        const { mutate } = useWishlist()
        const [isLoading, setIsLoading] = useState(false)

        const moveProductsBetweenWishlists = async (
            formInput: MutationMoveProductsBetweenWishlistsArgs
        ) => {
            setIsLoading(true)

            const response = await graphqlFetch<
                MutationMoveProductsBetweenWishlistsArgs,
                OutputInterface
            >({
                query: MOVE_PRODUCTS_BETWEEN_WISHLISTS,
                variables: formInput,
                locale
            })

            await mutate()
            setIsLoading(false)

            return response
        }

        return {
            isLoading,
            moveProductsBetweenWishlists
        }
    }
